import { queryOptions } from '@tanstack/react-query';
import { listSystemUsers } from '~/services/api/fetchers/systemUsers.api';
import { SystemUsersModel } from '~/shared/models/users/SystemUsersModel';

export const listSystemUsersQuery = (systemName: string) =>
  queryOptions({
    queryKey: ['systemUsers', systemName],
    queryFn: async () => {
      const response = await listSystemUsers(systemName);
      return new SystemUsersModel(response);
    },
  });
